/**
 * @typedef {'idle' | 'saving' | 'saved'} AutosaveState
 */

/** @type {Record<AutosaveState, string>} */
const TEKST = {
    idle: 'Wijzigingen worden vanzelf bewaard',
    saving: 'Opslaan…',
    saved: 'Opgeslagen',
}

/**
 * Toont bij het formulier zelf of er nog iets klaarstaat of dat het bewaard is.
 *
 * Bedoeld voor schermen die bewust géén opslaanknop hebben. De globale melding
 * onderin het scherm verdwijnt na vier seconden en staat ver van het veld; een
 * tester die er speciaal op lette miste hem twee keer, terwijl haar doel
 * letterlijk "zeker weten dat het bewaard is" was. Deze tekst **blijft staan**
 * tot er weer iets te bewaren valt. Zie docs/inbox.md #162.
 *
 * De begintekst legt bovendien uit waarom er geen opslaanknop is — dat was voor
 * een nieuwe gebruiker niet vanzelfsprekend.
 *
 * `role='status'` zorgt dat een schermlezer de verandering voorleest zonder de
 * gebruiker te onderbreken.
 *
 * **`reserve`.** De instellingenblokken willen in rust geen tekst (die legt
 * uit wat er nog moet gebeuren, niet wat er gebeurd is — docs/inbox.md #162),
 * maar de regel pas renderen bij de eerste opslag liet de hele tabel een regel
 * zakken terwijl de gebruiker nog aan het invullen was: klikken op het
 * code- en tariefveld landden in de titel (testronde 2026-10-08, B3). Met
 * `reserve` staat de regel er vanaf het begin, in rust leeg, zodat niets
 * verschuift.
 *
 * @param {object} props
 * @param {AutosaveState} props.status - Stand uit `useAutosaveField`
 * @param {boolean} [props.reserve] - In rust een lege regel van dezelfde hoogte in plaats van de uitlegtekst
 */
const AutosaveStatus = ({ status, reserve = false }) => {
    const stil = reserve && (status === 'idle' || !TEKST[status])
    return (
        <p className={`autosave-status autosave-status-${stil ? 'idle' : status}`} role='status'>
            {stil ? '\u00a0' : (TEKST[status] || TEKST.idle)}
        </p>
    )
}

export default AutosaveStatus
